import React from 'react';

import { Badge } from '@buildoutinc/blueprint-react/ui/Badge';

import { Button } from 'components/ui/button';

interface Props {
  label: string;
  onRemove: () => void;
  'data-testid'?: string;
}

export default function RemovableBadge({ label, onRemove, 'data-testid': testId }: Props) {
  return (
    <Badge data-testid={testId} variant="outline">
      {label}
      <Button
        appearance="muted"
        aria-label={`Remove ${label}`}
        className="ms-2 p-0"
        size="sm"
        variant="ghost"
        onClick={onRemove}
      >
        ×
      </Button>
    </Badge>
  );
}
